@if (autoplay==0) {
  <span>
    <iframe style="width: 100%; height:100%"
    [src]="youtubeUrl+img.img + '?autoplay=0' | safe: 'resourceUrl'" frameborder="0" allow="autoplay"></iframe>
  </span>
}

@if (autoplay==1) {
  <span>
    <iframe style="width: 100%; height:100%"
    [src]="youtubeUrl+img.img + '?autoplay=1' | safe: 'resourceUrl'" frameborder="0" allow="autoplay"></iframe>
  </span>
}
